<template>
    <InformeCard
        id="ocupacion"
        name="ocupacion"
        collapsable="true"
        title="Ocupación"
        class="width-responsive"
        @click="$refs.googleChart.draw()"
    >
        <ContentOrLoading>
            <div v-if="sectores" class="table-responsive">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Zona</th>
                            <th class="text-center">Aforo máximo</th>
                            <th class="text-center">Confirmados / Butacas cerradas</th>
                            <th class="text-center">% ocupación</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(sector, index) in sectores">
                            <tr :key="index">
                                <td>{{ sector.name }}</td>
                                <td class="text-center">{{ sector.aforo }}</td>
                                <td class="text-center">{{ sector.butacas_ocupadas }}</td>
                                <td class="text-center">
                                    {{ porcentaje_ocupacion(sector.butacas_ocupadas, sector.aforo) + ' %' }}
                                </td>
                            </tr>
                        </template>
                        <tr>
                            <td>TOTAL</td>
                            <td class="text-center">{{ aforo_total }}</td>
                            <td class="text-center">{{ confirmadas_total }}</td>
                            <td class="text-center">{{ media_ocupacion() + ' %' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <DesgloseOcupacion :valores_grafico="valores_grafico" ref="googleChart" />
        </ContentOrLoading>
    </InformeCard>
</template>

<script>
import InformeCard from "../../InformeCard";
import DesgloseOcupacion from "./DesgloseOcupacionComponent.vue";

export default {
    props: ['lista_id'],
    data() {
        return {
            sectores: null,
            valores_grafico: null,
            loading: false
        }
    },
    created() {
        this.getSectores();
    },
    computed: {
        total_sectores() {
            return this.sectores.reduce((accumulator, dato) => {
                return accumulator + parseInt(dato.aforo) - parseInt(dato.butacas_ocupadas);
            }, 0);
        },
        confirmadas_total() {
            return this.sectores.reduce((accumulator, dato) => {
                return accumulator + parseInt(dato.butacas_ocupadas);
            }, 0);
        },
        aforo_total() {
            return this.sectores.reduce((accumulator, dato) => {
                return accumulator + parseInt(dato.aforo);
            }, 0);
        }
    },
    methods: {
        porcentaje_ocupacion(confirmados, total) {
            if (total === 0) {
                return '-';
            }
            return parseFloat((confirmados / total * 100).toPrecision(2));
        },
        getSectores() {
            this.loading = true;

            const params = {
                filters: {},
                lista_id: this.lista_id,
            };

            this.$store.dispatch(this.config.getVuexAlias('back.abonos.informe.ocupacion'), params).then(res => {
                this.sectores = res.data.sectores;
                this.getGraficoOcupacion();
            }).finally(() => this.loading = false);
        },
        media_ocupacion() {
            var resultado = 0;

            if (this.sectores) {
                this.sectores.forEach(sector => {
                    resultado = resultado + this.porcentaje_ocupacion(sector.butacas_ocupadas, sector.aforo);
                });
    
                return (resultado / this.sectores.length).toFixed(2);
            }

            return '-';
        },
        getGraficoOcupacion : function(){
            var valores = [];

            valores.push(['Zona', 'Aforo']);
            valores.push(['TOTAL DISPONIBLE', this.total_sectores]);

            for(var i in this.sectores) {
                valores.push([this.sectores[i].name, this.sectores[i].butacas_ocupadas]);
            }    
            
            this.valores_grafico = valores;
        },
    },
    components: {
        InformeCard, DesgloseOcupacion
    }
}
</script>

<style scoped>
     @media (max-width: 700px) {
        .width-responsive {
            width: 320px;
        }
     }
</style>